module.exports = __webpack_public_path__ + "img/man_child_back.9c623af0.png";